import React, { FC } from 'react';

import { Icon } from '@rbilabs/universal-components';

import { t } from 'state/intl/translations';

import { Label, TextWithArrowButtonRoot } from './styled';
import { TextWithArrowButtonProps } from './types';

export const TextWithArrowButton: FC<React.PropsWithChildren<TextWithArrowButtonProps>> = ({
  onPress,
  messageId,
  withBorder = false,
}) => {
  return (
    <TextWithArrowButtonRoot
      href="#"
      onPress={event => {
        event?.preventDefault();
        onPress?.();
      }}
      withBorder={withBorder}
      accessibilityRole="link"
    >
      <Label variant="headerFour" accessibilityRole="header" accessibilityLevel={3}>
        {t(messageId as any)}
      </Label>
      <Icon variant="next" height="$3_5" width="$4" color="dark.200" />
    </TextWithArrowButtonRoot>
  );
};
